<script>
import toggle from '@utils/design/toggle-info'
import VisDeviceStateDetailProductivity from '@components/vis-device-state-history-detail-productivty'

import {
  filtersComputed,
  infoComputed,
  infoMethods,
  requestCancellationMethods,
  deviceEventCurrentMethods,
  deviceEventCurrentComputed,
} from '@state/helpers'

export default {
  components: { VisDeviceStateDetailProductivity },

  data: function() {
    return {
      setInterval: null,
    }
  },

  computed: {
    ...filtersComputed,
    ...infoComputed,
    ...deviceEventCurrentComputed,

    deviceEventCurrentByDevice: function() {
      return this.cachedEventCurrents.find(
        (DeviceEventCurrent) => DeviceEventCurrent.deviceId == this.$route.params.deviceId
      )
    },
  },

  created: function() {
    this.setInterval = setInterval(() => {
      this.fetchEventCurrents({ clearCache: true })
    }, 30000)
  },

  beforeDestroy() {
    this.cancelPendingRequests()
    clearInterval(this.setInterval)
  },

  methods: {
    ...infoMethods,
    ...requestCancellationMethods,
    ...deviceEventCurrentMethods,

    getName(item) {
      return item.meta && item.meta.label ? item.meta.label : item.name || null
    },

    isLast(index) {
      return index === this.list.length - 1
    },

    clickToggle: function(e) {
      toggle(true)
    },

    clickCompact: function(e) {
      this.setCompact({ compact: !this.selectedCompact })
    },
  },
}
</script>

<template>
  <VisDeviceStateDetailProductivity :device-event-current="deviceEventCurrentByDevice" />
</template>

<style lang="css">
.breadcrumb {
    min-height: 49px;
}
.breadcrumb-link {
  margin-left: 10px;
  font-size: 16px;
  color: #73818f;
  text-decoration: none;
}
.breadcrumb-link:hover {
  color: #fff;
  text-decoration: none;
}
</style>
